import { Box, Video } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"

import Image from "components/landing/image"
import StyledLink from "components/landing/link"
import Textarea from "components/landing/textarea"

import SplitBlock from "./components/split-block"

const ArticleSection = ({ section }) => {
  const { anchor_name, section_type } = section

  let content = null

  switch (section_type) {
    case "textarea":
      content = (
        <Textarea element={section.textarea} style={section.textarea.style} />
      )
      break
    case "image":
      content = (
        <StyledLink target="_blank" url={section.image.url}>
          <Image
            alt={section.image.alt}
            containerStyle={{ textAlign: "center" }}
            image={section.image}
            lazyload
          />
        </StyledLink>
      )
      break
    case "split-block":
      content = <SplitBlock section={section} />
      break
    case "video":
      content = <Video lazyload style={section.style} {...section.video} />
      break
  }

  return <Box id={anchor_name}>{content}</Box>
}

ArticleSection.propTypes = {
  section: PropTypes.object,
}

export default ArticleSection
